<template>
  <div class="container">
    <!-- 顶部渐变背景 -->
    <div class="header-bg"></div>

    <!-- 标题 -->
    <div class="header">
      <h1>登录查询</h1>
      <p>请在下方输入指定内容，进行信息查询</p>
    </div>

    <!-- 表单 -->
    <div class="form-container">
      <van-form @submit="onSubmit">
        <van-field v-model="idCard" label="身份证" placeholder="请输入身份证号" required />

        <van-field v-model="certificateNumber" label="证号" placeholder="请输入证号" required />

        <div class="submit-button">
          <van-button round block type="info" native-type="submit">确认查询</van-button>
        </div>
      </van-form>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer">
      <p>培训证书查询 - 2025</p>
    </div>
  </div>
</template>
  
  <script>
import { Form, Field, Button } from "vant";

export default {
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },

  data() {
    return {
      idCard: "",
      certificateNumber: "",
    };
  },

  methods: {
    onSubmit() {
      // 提交表单的逻辑
      if (!this.idCard || !this.certificateNumber) {
        this.$toast("请输入身份证号和证号");
        return;
      }
      const url = `/certList?certificateNumber=${this.certificateNumber}&idCard=${this.idCard}`;
      this.$router.push(url);
    },
  },
};
</script>
  
  <style scoped>
.container {
  position: relative;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

.header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 150px;
  background: linear-gradient(90deg, #0091ff, #64b5f6, #b3e5fc) !important;
  border-radius: 0 0 32px 32px;
  z-index: 0;
}

.header {
  text-align: center;
  padding: 20px;
  color: white;
  position: relative;
  z-index: 1;
}

.header h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

.header p {
  font-size: 16px;
  opacity: 0.9;
}

.form-container {
  background-color: white;
  border-radius: 16px;
  margin: 0 20px 0;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
}

.submit-button {
  margin-top: 30px;
}

.footer {
  text-align: center;
  margin-top: 40px;
  color: #999;
  font-size: 14px;
}
</style>